module.exports = __webpack_public_path__ + "img/ico-sort.f555bdcf.svg";